import { createBrowserRouter } from 'react-router-dom';
import App from '../App';
import DashboardContent from '../components/Dashboard/DashboardContent';
import Projects from '../components/Projects/Projects';
import ProjectsHomepage from '../components/Projects/ProjectsHomepage';
import WeeklyPlanner from '../components/WeeklyPlanner';
import RecurringTasks from '../components/RecurringTasks/RecurringTasks';
import TimeBlock from '../components/TimeBlock/TimeBlock';
import Login from '../components/Login';

export const router = createBrowserRouter([
    {
        path: '/login',
        element: <Login />
    },
    {
        path: '/',
        element: <App />,
        children: [
            {
                path: '/',
                element: <DashboardContent />,
                children: [
                    {
                        path: 'projects',
                        children: [
                            {
                                path: '',
                                element: <ProjectsHomepage />
                            },
                            {
                                path: ':projectId',
                                element: <Projects />
                            }
                        ]
                    },
                    {
                        path: 'weekly-planner',
                        element: <WeeklyPlanner />
                    },
                    {
                        path: 'recurring-tasks',
                        children: [
                            {
                                path: '',
                                element: <RecurringTasks />
                            },
                            {
                                path: 'new',
                                element: <RecurringTasks />
                            },
                            {
                                path: ':taskId',
                                element: <RecurringTasks />
                            }
                        ]
                    },
                    {
                        path: 'timeblock',
                        element: <TimeBlock />
                    },
                    {
                        path: '',
                        element: <WeeklyPlanner />
                    }
                ]
            }
        ]
    }
]); 